import { getDataset } from '../../../models/Datasets';
import { getDirectionService } from '../../../services/directions/DirectionServiceFactory';
import store from 'store';

const DirectionValueGetter = (params) => {
    if (params.data) {
        const {
            datasetId,
            loadZone,
            dischargeZone,
            loadLocationParts,
            deliveryZone,
            deliveryLocationParts,
            groupId,
        } = params.data;
        const { directionLogic } = params.context;
        const deliveryDirectionMapping = store
            .getState()
            .user.groupsSettings.find((x) => x.groupId == groupId)
            ?.groupSettings.useDeliveryZoneForDirectionMapping;

        const autoPopulateDirectionEnabled =
            getDataset(datasetId).autoPopulateDirectionEnabled;
        const directionService = getDirectionService(directionLogic);

        if (!autoPopulateDirectionEnabled || !directionService) {
            return '';
        }

        if (loadZone || !deliveryDirectionMapping) {
            const direction = directionService.calculateDirection(
                loadZone,
                dischargeZone,
                loadLocationParts
            );
            return direction;
        }

        const direction = directionService.calculateDirection(
            deliveryZone,
            dischargeZone,
            deliveryLocationParts
        );

        return direction;
    }

    return '';
};

export default DirectionValueGetter;
